import { List } from 'immutable';
import { Menus } from 'records/Menu';
import BaseList from 'records/BaseList';

import {
  MENUS_ASYNC_ACTION_START,
  MENUS_ASYNC_ACTION_ERROR,
  MENUS_ASYNC_ACTION_SUCCESS,
  MENUS_ASYNC_UPDATE_SUCCESS,
  MENUS_RESET_STATE,
  MENUS_SET_DUPMENUID,
} from 'actions/menus';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [MENUS_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [MENUS_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [MENUS_ASYNC_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [MENUS_ASYNC_UPDATE_SUCCESS]: (state, action) => {
    const menusData = Menus(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: menusData,
    });
  },
  [MENUS_RESET_STATE]: () => {
    return initialState;
  },
  [MENUS_SET_DUPMENUID]: (state, action) => {
    return state.merge({
      sortKey: action.data,
    });
  },
};

export default function menus(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
